import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

export default function TableBody({ className, children }) {
  return <tbody className={cn('cp-table-body', className)}>{children}</tbody>;
}

TableBody.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired
};
